export enum Status {
  ACTIVE = 'ACTIVE',
  DEPRECATED = 'DEPRECATED',
  DELETE = 'DELETE',
  DRAFT = 'DRAFT',
}
